import React from 'react'
import OnVisible from 'react-on-visible'
import { Section } from 'newComponents'
import './styles.scss'

const Wysiwyg = (props) => {
  const { data, location } = props
  const { primary, __typename } = data
  const { wysiwyg, text_align: textAlign } = primary

  // content check
  const wysiwygHtml = wysiwyg?.html

  // removing \t and replacing with space characters for code
  const wysiwygCleaned = wysiwygHtml
    .replace(/\\t/g, '&nbsp;&nbsp;&nbsp;&nbsp;')
    .replace(/\[(\S+)[^\]]*][^\[]*\[\/\1\]/g, '')
    .replace(/{code}/g, '<code>')
    .replace(/{[/]code}/g, '</code>')

  const isWebinar = location.pathname.includes('webinars')
  const isPage = __typename === 'PrismicPageBodyWysiwyg'

  const webinarVariant = isWebinar ? 'webinar-variant' : ''
  const pageVariant = isPage ? 'page-variant' : ''
  const alignment = textAlign ? textAlign.toLowerCase() : ''

  return (
    <OnVisible className={`wysiwyg ${webinarVariant} ${pageVariant} ${alignment}`}>
      <Section>
        {wysiwygHtml && (
          <div
            className="wysiwyg-content"
            dangerouslySetInnerHTML={{
              __html: wysiwygCleaned
            }}
          />
        )}
      </Section>
    </OnVisible>
  )
}

export default Wysiwyg
